module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages"
  }, [_c('sub-ibox-title', [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("微信菜单管理")])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "fx"
  }, [_c('div', {
    staticClass: "menu fx-shrink"
  }, [_c('h3', [_vm._v(_vm._s(_vm.publicInfo.nick_name || '公众号名称'))]), _vm._v(" "), _c('div', {
    staticClass: "menu-btn-cont"
  }, [(_vm.menu) ? _c('ul', {
    staticClass: "fx menu-btn fx-align"
  }, [_vm._l((_vm.menu.button || []), function(item, index) {
    return _c('li', {
      staticClass: "fx-fill fx-align "
    }, [_c('dl', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.active == index),
        expression: "active==index"
      }]
    }, [_vm._l((item.sub_button), function(subItem, subIndex) {
      return _c('dd', {
        class: {
          'active': _vm.subActive == subIndex
        },
        on: {
          "click": function($event) {
            return _vm.handleSelectedMenu(index, subIndex)
          }
        }
      }, [_vm._v(_vm._s(subItem.name))])
    }), _vm._v(" "), (item.sub_button.length < 5) ? _c('dd', {
      staticClass: "sub-add",
      on: {
        "click": function($event) {
          return _vm.handleAddMenu(item.sub_button)
        }
      }
    }, [_c('span', {
      staticClass: "icon-add"
    })]) : _vm._e()], 2), _vm._v(" "), _c('div', {
      staticClass: "fx-fill fx-align btns",
      class: [_vm.active == index && _vm.subActive == null ? 'active' : ''],
      on: {
        "click": function($event) {
          return _vm.handleSelectedMenu(index)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(item.name) + "\n\t\t\t\t\t\t\t")])])
  }), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menu.button.length < 3),
      expression: "menu.button.length <3"
    }],
    staticClass: "fx-fill fx-align",
    on: {
      "click": function($event) {
        return _vm.handleAddMenu(_vm.menu.button)
      }
    }
  }, [_c('div', {
    staticClass: "fx-fill fx-align btns icon-add"
  })])], 2) : _vm._e()])]), _vm._v(" "), (_vm.editBtn.sub_button) ? _c('div', {
    staticClass: "menu-edit fx-fill b-r-5"
  }, [_c('div', {
    staticClass: "p-b-20"
  }, [_c('p', {
    attrs: {
      "align": "right"
    }
  }, [_c('a', {
    staticClass: "del-menu",
    on: {
      "click": _vm.handleDelMenu
    }
  }, [_vm._v("删除当前菜单")])])]), _vm._v(" "), _c('div', {
    staticClass: "fx fx-y-center"
  }, [_c('p', [_vm._v("菜单名称：")]), _vm._v(" "), _c('p', {
    staticClass: "fx-fill"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editBtn.name),
      expression: "editBtn.name"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "字数不超过6个汉字",
      "maxlength": "6"
    },
    domProps: {
      "value": (_vm.editBtn.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editBtn, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editBtn.sub_button.length <= 0),
      expression: "editBtn.sub_button.length <=0"
    }]
  }, [_c('div', {
    staticClass: "fx p-t-20 p-b-20"
  }, [_c('p', [_vm._v("菜单内容：")]), _vm._v(" "), _c('div', {
    staticClass: "fx radio-cont"
  }, [_c('p', {
    staticClass: "fx fx-y-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editBtn.type),
      expression: "editBtn.type"
    }],
    staticClass: "radio",
    attrs: {
      "type": "radio",
      "id": "news",
      "name": "chack",
      "value": "media_id"
    },
    domProps: {
      "checked": _vm._q(_vm.editBtn.type, "media_id")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.editBtn, "type", "media_id")
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "m-l-5",
    attrs: {
      "for": "news"
    }
  }, [_vm._v("发送素材")])]), _vm._v(" "), _c('p', {
    staticClass: "fx fx-y-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editBtn.type),
      expression: "editBtn.type"
    }],
    staticClass: "radio",
    attrs: {
      "type": "radio",
      "id": "link",
      "name": "chack",
      "value": "view"
    },
    domProps: {
      "checked": _vm._q(_vm.editBtn.type, "view")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.editBtn, "type", "view")
      }
    }
  }), _c('label', {
    staticClass: "m-l-5",
    attrs: {
      "for": "link"
    }
  }, [_vm._v("跳转连接")])]), _vm._v(" "), _c('p', {
    staticClass: "fx fx-y-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editBtn.type),
      expression: "editBtn.type"
    }],
    staticClass: "radio",
    attrs: {
      "type": "radio",
      "id": "click",
      "name": "chack",
      "value": "click"
    },
    domProps: {
      "checked": _vm._q(_vm.editBtn.type, "click")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.editBtn, "type", "click")
      }
    }
  }), _c('label', {
    staticClass: "m-l-5",
    attrs: {
      "for": "click"
    }
  }, [_vm._v("发送关键词")])]), _vm._v(" "), _c('p', {
    staticClass: "fx fx-y-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editBtn.type),
      expression: "editBtn.type"
    }],
    staticClass: "radio",
    attrs: {
      "type": "radio",
      "id": "miniprogram",
      "name": "chack",
      "value": "miniprogram"
    },
    domProps: {
      "checked": _vm._q(_vm.editBtn.type, "miniprogram")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.editBtn, "type", "miniprogram")
      }
    }
  }), _c('label', {
    staticClass: "m-l-5",
    attrs: {
      "for": "miniprogram"
    }
  }, [_vm._v("小程序")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editBtn.type == 'media_id'),
      expression: "editBtn.type =='media_id'"
    }]
  }, [_c('div', {
    staticClass: "fx fx-y-center"
  }, [_c('p', {
    staticClass: "p-r-10"
  }, [_vm._v("素材名称:")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mediaName),
      expression: "mediaName"
    }],
    staticClass: "fx-fill"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mediaName),
      expression: "mediaName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": "disabled",
      "placeholder": "请选择素材"
    },
    domProps: {
      "value": (_vm.mediaName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mediaName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.mediaName),
      expression: "!mediaName"
    }],
    staticClass: "fx-fill"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editBtn.media_id),
      expression: "editBtn.media_id"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": "disabled",
      "placeholder": "media_id"
    },
    domProps: {
      "value": (_vm.editBtn.media_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editBtn, "media_id", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p-10"
  }, [_c('a', {
    staticClass: "z-btn z-btn-primary b-r-3",
    on: {
      "click": _vm.handleShowLayer
    }
  }, [_vm._v(_vm._s(_vm.editBtn.media_id ? '重选素材' : '选择素材'))])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editBtn.type == 'view'),
      expression: "editBtn.type =='view'"
    }]
  }, [_c('div', {
    staticClass: "fx fx-y-center"
  }, [_c('p', {
    staticClass: "p-r-10"
  }, [_vm._v("跳转连接:")]), _vm._v(" "), _c('p', {
    staticClass: "fx-fill"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editBtn.url),
      expression: "editBtn.url"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "跳转连接"
    },
    domProps: {
      "value": (_vm.editBtn.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editBtn, "url", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editBtn.type == 'click'),
      expression: "editBtn.type =='click'"
    }]
  }, [_c('div', {
    staticClass: "fx fx-y-center"
  }, [_c('p', {
    staticClass: "p-r-10"
  }, [_vm._v("关键词:")]), _vm._v(" "), _c('p', {
    staticClass: "fx-fill"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editBtn.key),
      expression: "editBtn.key"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "请输入关键词"
    },
    domProps: {
      "value": (_vm.editBtn.key)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editBtn, "key", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p-t-10 tips"
  }, [_vm._v("tips:这里需要配合关键词推送消息一起使用")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editBtn.type == 'miniprogram'),
      expression: "editBtn.type =='miniprogram'"
    }]
  }, [_c('div', {
    staticClass: "fx fx-y-center"
  }, [_c('p', {
    staticClass: "p-r-10"
  }, [_vm._v("小程序的appid:")]), _vm._v(" "), _c('p', {
    staticClass: "fx-fill"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editBtn.appid),
      expression: "editBtn.appid"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "请输入小程序的appid"
    },
    domProps: {
      "value": (_vm.editBtn.appid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editBtn, "appid", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "fx fx-y-center p-t-10"
  }, [_c('p', {
    staticClass: "p-r-10"
  }, [_vm._v("小程序的页面路径:")]), _vm._v(" "), _c('p', {
    staticClass: "fx-fill"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editBtn.pagepath),
      expression: "editBtn.pagepath"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "请输入小程序的页面路径，如：pages/index"
    },
    domProps: {
      "value": (_vm.editBtn.pagepath)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editBtn, "pagepath", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p-t-10 tips"
  }, [_vm._v("tips:需要和公众号进行关联才可以把小程序绑定带微信菜单上哟！")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editBtn.sub_button),
      expression: "!editBtn.sub_button"
    }],
    staticClass: "menu-edit"
  }, [_vm._v("\n\t\t\t\t请选择菜单\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "m-t-20 submit-btn"
  }, [_c('a', {
    staticClass: "z-btn z-btn-primary b-r-3",
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("保存并发布菜单")])])]), _vm._v(" "), _c('z-layers-material', {
    attrs: {
      "is-show": _vm.isLayerBox,
      "title": '素材管理'
    },
    on: {
      "handleOk": _vm.handleConfirm,
      "handleCancel": _vm.handleCancel
    }
  }, [_c('z-material', {
    attrs: {
      "is-get-material": _vm.isLayerBox,
      "is-tab-bar": true,
      "type": 'news'
    },
    on: {
      "handleSelectMaterial": _vm.handleSelectMaterial
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-166c8f50","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/mp/wechat/WxMenu.vue
// module id = 820
// module chunks = 0